import { useState, useEffect } from 'react';
import { useAuth } from '../providers/AuthProvider';
import { getUserNickname } from '../services/userProfileService';

/**
 * Custom hook to get and manage user nickname
 * @returns {string} User's nickname or 'User' as fallback
 */
export const useUserNickname = () => {
  const { user } = useAuth();
  const [nickname, setNickname] = useState('User');

  useEffect(() => {
    if (user) {
      const userNickname = getUserNickname(user);
      setNickname(userNickname || 'User');
    } else {
      setNickname('User');
    }
  }, [user]);

  return nickname;
};

